// Venue subpages. Each entry powers a /venues/{slug} page with venue-specific
// content, films, and reviews filtered by mention.
//
// All YouTube IDs MUST come from the Wedding Video Essex channel:
// https://www.youtube.com/channel/UCKl2o-N4_GzlqLSyMGzSvaA
// Every film below was verified against the WVE channel's Full Feature Films
// playlist (PL9tAB3F7qycVDBTIZl8YXCoPdTnS3oU2O).

const film = (id, couple, kind = "full-film", date = "2024-01-01") => ({
  id,
  title: couple ? `${couple}'s Wedding Film` : "Venue Promo",
  couple,
  kind,
  uploadDate: date,
});

export const VENUE_PAGES = {
  "gosfield-hall": {
    name: "Gosfield Hall",
    slug: "gosfield-hall",
    location: "Halstead, Essex",
    postcode: "CO9 1SF",
    style: "Mansion · 10 acres · Exclusive use",
    officialUrl: "https://www.gosfield-hall.co.uk/",
    blurb:
      "Gosfield Hall is a Grade II* listed Tudor mansion set in ten acres of private grounds overlooking Gosfield Lake. One wedding per day, fully exclusive use, with the Old Library, the Salon and the Long Gallery offering some of the most cinematic interiors in Essex.",
    films: [
      film("jxj7B8nWG1U", "Sarah & Marty", "full-film", "2025-10-03"),
      film("AGtZI8qYfdo", "Oyinade & David", "full-film", "2026-02-04"),
      film("R_HTHAxsEjU", "Ellie & Alex", "trailer", "2024-10-24"),
      film("iGgdaZU-FNU", null, "venue-promo", "2025-02-26"),
    ],
    reviewKeywords: ["gosfield"],
  },
  "leez-priory": {
    name: "Leez Priory",
    slug: "leez-priory",
    location: "Great Leighs, Chelmsford, Essex",
    postcode: "CM3 1JP",
    style: "Tudor priory · Exclusive use · 40 acres",
    officialUrl: "https://www.leez-priory.co.uk/",
    blurb:
      "Leez Priory is a Tudor manor and former 13th-century priory set in 40 acres of Essex countryside near Chelmsford. Exclusive-use, one wedding per day, and one of the most photogenic ceremony spaces in the county.",
    films: [
      film("7llK4VMIw_A", "Gemma & Curtis"),
      film("2Ab5zos4QqY", "Nikki & Dave"),
      film("Q8GecesihHw", "Emma & Jamie"),
      film("Lmdntu8Es1E", "Rebecca & Daniel"),
    ],
    reviewKeywords: ["leez"],
  },
  "crondon-park": {
    name: "Crondon Park",
    slug: "crondon-park",
    location: "Stock, Essex",
    postcode: "CM4 9DP",
    style: "Country estate · Barn · Exclusive use",
    officialUrl: "https://www.crondonpark.com/",
    blurb:
      "Crondon Park sits on a private 250-acre estate in Stock, with a beautifully restored barn ceremony space, vaulted timber interiors and sweeping views across Essex farmland.",
    films: [
      film("ILIJzdToXuI", "Daisy & Reece"),
      film("wQrh-5pRzE0", "Katie & Darren"),
      film("l9iXeYyXzhY", "Cassie & George"),
      film("S9nEzgmNDZc", null, "venue-promo", "2023-02-10"),
    ],
    reviewKeywords: ["crondon"],
  },
  "greenwoods-hotel-spa-retreat": {
    name: "Greenwoods Hotel Spa & Retreat",
    slug: "greenwoods-hotel-spa-retreat",
    location: "Stock, Essex",
    postcode: "CM4 9BE",
    style: "Boutique country hotel · Spa · Award-winning",
    officialUrl: "https://greenwoodshotel.com/",
    blurb:
      "Greenwoods is a Grade II listed manor house hotel and spa in Stock, Essex. Wedding Video Essex is a recommended supplier and has filmed dozens of weddings here across the manor, terrace and orangery.",
    films: [
      film("TQdjtjhX6M0", "Chantelle & Joseph"),
      film("p4QkS_tmzA8", "Ryan & Andrew"),
      film("YrwDkomAXrQ", "Sophie & Alex"),
      film("3P63E5Skmm0", null, "venue-promo", "2022-12-01"),
    ],
    reviewKeywords: ["greenwoods"],
  },
  "friern-manor": {
    name: "Friern Manor Country House",
    slug: "friern-manor",
    location: "Brentwood, Essex",
    postcode: "CM13 3UB",
    style: "Country house · Bridge of Sighs · Exclusive use",
    officialUrl: "https://www.friernmanor.com/",
    blurb:
      "Friern Manor is a Grade II listed country house in Brentwood with a fairy-tale Bridge of Sighs walkway, landscaped lawns and exclusive-use weddings.",
    films: [
      film("xRvIBqIWSbA", "Chloe & Ben"),
      film("alWJvE2tHlY", "Chloe & Connor"),
      film("ARvyP3r3XE8", "Katie & George"),
      film("g8Sxnhb7Ics", "Laura & Daniel"),
    ],
    reviewKeywords: ["friern"],
  },
  "hatfield-place": {
    name: "Hatfield Place",
    slug: "hatfield-place",
    location: "Hatfield Peverel, Essex",
    postcode: "CM3 2EZ",
    style: "Georgian manor · Orangery · Exclusive use",
    officialUrl: "https://hatfieldplace.com/",
    blurb:
      "Hatfield Place is a Grade II* Georgian manor near Chelmsford with an Orangery ceremony space, walled gardens and one of the most light-filled wedding settings in Essex.",
    films: [
      film("TSGJyA-meX8", "Tayla & Danny"),
      film("8WNXHaQw2Dk", "Chloe & Johnny"),
      film("uYZVinUuCE8", "Maggi & Ryan"),
      film("u80oyJEqPBo", "Jade & Josh"),
    ],
    reviewKeywords: ["hatfield place", "hatfield"],
  },
  "channels": {
    name: "Channels Retreat",
    slug: "channels",
    location: "Little Waltham, Chelmsford, Essex",
    postcode: "CM3 3PT",
    style: "Country club · Lakeside · Outdoor ceremonies",
    officialUrl: "https://www.channelsestate.co.uk/",
    blurb:
      "Channels Retreat is a lakeside country club near Chelmsford with outdoor ceremony decks, a contemporary clubhouse and a relaxed, garden-led wedding atmosphere.",
    films: [
      film("J5Ijf7os_wA", "Ellie & Jordan"),
      film("W2U5fpRNGjk", "Jessica & Jamie"),
      film("h9cUe5tsY3k", "Nim & Stephen"),
      film("A49s7aekJ-M", "Amber & Josh"),
    ],
    reviewKeywords: ["channels"],
  },
  "warren-estate": {
    name: "The Warren Estate",
    slug: "warren-estate",
    location: "Woodham Walter, Essex",
    postcode: "CM9 6RW",
    style: "Country estate · Lakeside · Marquee weddings",
    officialUrl: "https://www.thewarrenestate.co.uk/",
    blurb:
      "The Warren Estate is a private country estate in Maldon with lakeside marquee weddings, a 9-hole golf course and award-winning grounds.",
    films: [
      film("X_Whjwqy6lI", "Jess & Pete"),
      film("hJnzRkRFuj0", "Beth & Nick"),
      film("uvc6HYCPUWE", "Lois & Tommy"),
      film("QcmgME010MU", "Paige & Richard"),
    ],
    reviewKeywords: ["warren"],
  },
  "parklands-quendon-hall": {
    name: "Parklands Quendon Hall",
    slug: "parklands-quendon-hall",
    location: "Quendon, Saffron Walden, Essex",
    postcode: "CB11 3XN",
    style: "Country estate · Grade II* listed · 47 acres",
    officialUrl: "https://www.parklandsweddingvenue.co.uk/",
    blurb:
      "Parklands Quendon Hall is a 17th-century manor set in 47 acres of grounds, with a glass-walled Garden Pavilion that opens onto the lawn for outdoor ceremonies.",
    films: [
      film("RHZGRcf0RQo", "Alisha & Dan"),
      film("yiIvnO9d1HU", "Helen & Daniel"),
      film("SLQoiRrK73Y", "Charlotte & Tom"),
    ],
    reviewKeywords: ["quendon", "parklands"],
  },
  "fennes": {
    name: "Fennes",
    slug: "fennes",
    location: "Bocking, Braintree, Essex",
    postcode: "CM7 5PL",
    style: "Country estate · Barn · Exclusive use",
    officialUrl: "https://www.fennes.co.uk/",
    blurb:
      "Fennes is a Georgian country house and barn near Braintree with exclusive-use weddings, period interiors and a celebrated reputation for relaxed, party-led celebrations.",
    films: [
      film("oV5Ft__hPAw", "Amy & Sam"),
      film("DBK3I5_a9-U", "Chelsea & Arron"),
      film("-zmUbvogE_A", "Sophie & Kunal"),
      film("wIKqdJxdsGo", null, "venue-promo", "2022-06-01"),
    ],
    reviewKeywords: ["fennes"],
  },
  "vaulty-manor": {
    name: "Vaulty Manor",
    slug: "vaulty-manor",
    location: "Goldhanger, Maldon, Essex",
    postcode: "CM9 8AU",
    style: "Country manor · Outdoor ceremonies · Exclusive use",
    officialUrl: "https://www.vaultymanor.co.uk/",
    blurb:
      "Vaulty Manor sits on a working country estate near Maldon, with outdoor woodland ceremonies, a barn reception and stunning rolling Essex views.",
    films: [
      film("wsLeDBcoHs0", "Alicia & Harry"),
      film("TIySJc5yU2A", "Charlotte & Taylor"),
      film("up7zg3Vv-lk", "Sarah & Laurence"),
      film("El5lBto6cXQ", "Katey & Sam"),
    ],
    reviewKeywords: ["vaulty"],
  },
  "hutton-hall": {
    name: "Hutton Hall",
    slug: "hutton-hall",
    location: "Brentwood, Essex",
    postcode: "CM13 1RT",
    style: "Country manor · Brentwood",
    officialUrl: "https://huttonhall.uk/",
    blurb:
      "Hutton Hall is a country manor in Brentwood with a relaxed wedding atmosphere, beautiful grounds and a warm, intimate ceremony space.",
    films: [
      film("aAQdUM9gSs0", "Anna & Ray"),
      film("vQlelCmZiRE", "Vanessa & Jermaine"),
      film("5pAXY73rj3c", "Carly & Darren"),
    ],
    reviewKeywords: ["hutton"],
  },
  "wivenhoe-house": {
    name: "Wivenhoe House",
    slug: "wivenhoe-house",
    location: "Colchester, Essex",
    postcode: "CO4 3SQ",
    style: "Georgian country house hotel · University parkland",
    officialUrl: "https://www.wivenhoehouse.co.uk/",
    blurb:
      "Wivenhoe House is a Georgian country house hotel set in University of Essex parkland, with elegant interiors and one of the most refined wedding settings in Colchester.",
    films: [
      film("CrxsalOWmxQ", "Priya & Nick"),
      film("ijDo8o74mwk", "Charlotte & Lee"),
    ],
    reviewKeywords: ["wivenhoe"],
  },
  "apton-hall": {
    name: "Apton Hall",
    slug: "apton-hall",
    location: "Rochford, Essex",
    postcode: "SS4 1JF",
    style: "Country manor · Exclusive use · 16 acres",
    officialUrl: "https://www.aptonhall.co.uk/",
    blurb:
      "Apton Hall is a country manor near Rochford with 16 acres of private grounds, a tithe barn ceremony space and one of the most picturesque wedding settings on the Essex coast.",
    films: [
      film("Aqz2GCSlNmU", "Hayley & Dan"),
      film("-olmjO2betY", "Emily & Alex"),
      film("hbHdSgHfauE", "Annie & Charlie"),
    ],
    reviewKeywords: ["apton"],
  },
  "braxted-park": {
    name: "Braxted Park",
    slug: "braxted-park",
    location: "Great Braxted, Witham, Essex",
    postcode: "CM8 3GA",
    style: "Country estate · 18th century mansion · 500 acres",
    officialUrl: "https://www.braxtedpark.com/",
    blurb:
      "Braxted Park is an 18th-century country estate near Witham set in 500 acres of private parkland, with a stunning Orangery, walled gardens and exclusive-use weddings.",
    films: [
      film("3WiCAD4a83o", "Kelsie & Stuart"),
      film("vPnji9ZS7GQ", "Christina & Liam"),
      film("w3s8_MjOqD0", "Debbie & Nigel"),
      film("_fVo8AlkYIY", "Sophie & Ben"),
    ],
    reviewKeywords: ["braxted"],
  },
  "high-house-weddings": {
    name: "High House Weddings",
    slug: "high-house-weddings",
    location: "Althorne, Essex",
    postcode: "CM3 6BX",
    style: "Country barn · Exclusive use · Garden ceremonies",
    officialUrl: "https://highhouseweddings.co.uk/",
    blurb:
      "High House Weddings is a beautifully restored Essex barn venue with a tithe barn ceremony space, outdoor garden options and a relaxed, country-wedding atmosphere.",
    films: [
      film("tSAyeoBfnOk", "Laura & Scott"),
      film("RGPac3bPqmg", "Katie & Matt"),
      film("Ucao7K8lHCM", "Sue & Gary"),
      film("Q9CDBZfPNLk", "Ellie & Jarrad"),
    ],
    reviewKeywords: ["high house"],
  },
  "maidens-barn": {
    name: "Maidens Barn",
    slug: "maidens-barn",
    location: "Hatfield Peverel, Essex",
    postcode: "CM3 2EP",
    style: "Restored Essex barn · Exclusive use",
    officialUrl: "https://www.maidensbarn.com/",
    blurb:
      "Maidens Barn is a beautifully restored 16th-century barn near Hatfield Peverel with exclusive-use weddings and one of the most characterful timber ceremony spaces in Essex.",
    films: [film("lgZ7e93OaAA", "Shelly & Charlie")],
    reviewKeywords: ["maidens barn", "maidens"],
  },
  "mulberry-house": {
    name: "Mulberry House",
    slug: "mulberry-house",
    location: "Ongar, Essex",
    postcode: "CM5 9JQ",
    style: "Country manor · Boutique · Walled garden",
    officialUrl: "https://www.mulberryhouseessex.co.uk/",
    blurb:
      "Mulberry House is a boutique country wedding venue near Ongar with a walled garden, intimate ceremony spaces and a celebrated family-run hospitality.",
    films: [
      film("Dqwuvg89XQ4", "Janet & Antony"),
      film("eYNiCp2WZr8", "Georgia & Lauren"),
      film("W7_EYzj9OVY", "Tanya & John"),
      film("Tjr8Vr7gkFk", null, "venue-promo", "2022-09-01"),
    ],
    reviewKeywords: ["mulberry"],
  },
  "ingrebourne-links": {
    name: "Ingrebourne Links",
    slug: "ingrebourne-links",
    location: "Hornchurch, Essex",
    postcode: "RM12 6QX",
    style: "Golf club · Country setting · Romford area",
    officialUrl: "https://ingrebournelinks.co.uk/",
    blurb:
      "Ingrebourne Links is a country golf club in Hornchurch offering elegant wedding ceremonies, panoramic course views and a relaxed wedding atmosphere on the Essex/London border.",
    films: [film("E7ysYSSTyxk", "Charlotte & Brandon")],
    reviewKeywords: ["ingrebourne"],
  },
  "east-mersea-hall": {
    name: "East Mersea Hall",
    slug: "east-mersea-hall",
    location: "East Mersea, Colchester, Essex",
    postcode: "CO5 8TY",
    style: "Coastal country manor · Exclusive use",
    officialUrl: "https://www.eastmerseahall.co.uk/",
    blurb:
      "East Mersea Hall is an Elizabethan country manor on Mersea Island with exclusive-use coastal weddings and one of the most unique seaside settings in Essex.",
    films: [
      film("pS2kSxzBkHU", "Vanessa & Matthew"),
      film("t0aZfRIPAx0", "Zoe & Louis"),
    ],
    reviewKeywords: ["mersea"],
  },
  "downham-hall": {
    name: "Downham Hall",
    slug: "downham-hall",
    location: "Downham, Billericay, Essex",
    postcode: "CM11 1QZ",
    style: "Country manor · Exclusive use",
    officialUrl: "https://www.downhamhall.com/",
    blurb:
      "Downham Hall is a country manor wedding venue near Billericay with exclusive-use weddings, landscaped grounds and elegant interior ceremony spaces.",
    films: [
      film("gJhFfyxThHQ", "Megan & Joe"),
      film("bFy-3r7ojIM", "Jasmine & Sam"),
    ],
    reviewKeywords: ["downham"],
  },
  "little-channels": {
    name: "Little Channels",
    slug: "little-channels",
    location: "Little Waltham, Chelmsford, Essex",
    postcode: "CM3 3PT",
    style: "Lakeside venue · Outdoor ceremonies",
    officialUrl: "https://www.littlechannels.co.uk/",
    blurb:
      "Little Channels is the sister property of Channels Retreat, with a lakeside ceremony pavilion and a relaxed, garden-led wedding atmosphere on the Chelmsford estate.",
    films: [
      film("RkXIZBmOuWg", "Katie & Andy"),
      film("TLa9lCYOVBc", "Nicola & Ethan"),
      film("5Ukq3j9Y74E", "Danielle & Spencer"),
    ],
    reviewKeywords: ["little channels"],
  },
  "warley-park": {
    name: "Warley Park",
    slug: "warley-park",
    location: "Brentwood, Essex",
    postcode: "CM13 3DX",
    style: "Country club · Golf · 220 acres",
    officialUrl: "https://www.warleyparkgolfclub.co.uk/",
    blurb:
      "Warley Park is a country club and golf course in Brentwood with 220 acres of private grounds and elegant clubhouse wedding ceremonies.",
    films: [
      film("9isUktssG_Q", "Denika & Seda"),
      film("GmORDPhpLPM", "Rebecca & Shaun"),
    ],
    reviewKeywords: ["warley"],
  },
  "stock-brook-manor": {
    name: "Stock Brook Manor",
    slug: "stock-brook-manor",
    location: "Billericay, Essex",
    postcode: "CM12 0SP",
    style: "Country club · Hotel · Golf",
    officialUrl: "https://www.stockbrook.com/",
    blurb:
      "Stock Brook Manor is a country club and hotel in Billericay with 250 acres of private grounds, two golf courses and an elegant wedding suite.",
    films: [
      film("DUcptPMl3Oc", "Sarah & Ryan"),
      film("9MtZPS-Mmpo", "Lottie & Alex"),
      film("V58eGt8gJjw", "Katie & Thomas"),
      film("Cb1dWFxgAkY", "Clair & Darren"),
    ],
    reviewKeywords: ["stock brook", "stockbrook"],
  },
  "swynford-manor": {
    name: "Swynford Manor",
    slug: "swynford-manor",
    location: "Six Mile Bottom, Cambridgeshire (Essex border)",
    postcode: "CB8 0UE",
    style: "Country manor · Exclusive use",
    officialUrl: "https://www.swynfordmanor.com/",
    blurb:
      "Swynford Manor is a country manor on the Cambridgeshire/Essex border with exclusive-use weddings, landscaped grounds and elegant ceremony spaces.",
    films: [
      film("FrpevUqJLPU", "Alicia & Levi"),
      film("8z9o94c1YOE", "Shona & Anthony"),
    ],
    reviewKeywords: ["swynford"],
  },
  "gaynes-park": {
    name: "Gaynes Park",
    slug: "gaynes-park",
    location: "Epping, Essex",
    postcode: "CM16 7RJ",
    style: "Country house · 400 acres · Mill Barn",
    officialUrl: "https://gaynespark.co.uk/",
    blurb:
      "Gaynes Park is a country estate in Epping with 400 acres of grounds, a Mill Barn ceremony space and one of the most popular outdoor wedding settings in Essex.",
    films: [
      film("KTLcIqddWSE", "Emma & Mark"),
      film("1DXk4bMe3WM", "Leah & Josh"),
      film("VrSkVBdBEjM", "Hannah & Brad"),
      film("IwzzvUeYHxw", "Charlotte & Joe"),
    ],
    reviewKeywords: ["gaynes"],
  },
};
